/* global wx */

// import Swiper core and required modules
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import img0 from '../../assets/swiper0.png';
import img1 from '../../assets/swiper1.png';
import img2 from '../../assets/swiper2.png';
import locate from '../../assets/locate.png';
import phone from '../../assets/phone.png';
import { Typography, Grid, Box, Stack, Rating, Container } from "@mui/material"
import { useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { useTheme } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { addLiked, addRecord } from '../../store/features/my';



export default function App() {

  const theme = useTheme();
  const navigate = useNavigate();
  const storageURL = process.env.REACT_APP_Stroage_URL;
  const { currentYetaiDetail } = useSelector(store => (store.yetai));
  const { yetaiLiked } = useSelector(store => (store.my));

  const daoHangHandler = () => {
    console.log('daohang!')
    console.log("currentYetaiDetail", currentYetaiDetail)

    let lat;
    let lng
    // if (currentYetaiDetail.coordinates) {
    //   lat = parseFloat(currentYetaiDetail.coordinates.split(',')[1] || 0);
    //   lng = parseFloat(currentYetaiDetail.coordinates.split(',')[0] || 0);
    // }
    lat = currentYetaiDetail.latitude;
    lng = currentYetaiDetail.longitude;
    wx.openLocation({
      latitude: lat, // 纬度，浮点数，范围为90 ~ -90
      longitude: lng, // 经度，浮点数，范围为180 ~ -180。
      name: currentYetaiDetail.name, // 位置名
      address: currentYetaiDetail.addr, // 地址详情说明
      scale: 10, // 地图缩放级别,整形值,范围从1~28。默认为大
    });
    // navigate('/daohang?id=1&y=2');
  }
  const phoneHandler = () => {
    console.log(currentYetaiDetail)
    window.location.href = 'tel:' + currentYetaiDetail.tel;
  }


  const likedClick = () => {
    dispatch(addLiked(currentYetaiDetail.id))
  }

  const dispatch = useDispatch();
  useEffect(() => {
    // viewed
    if(currentYetaiDetail)
    {
      dispatch(addRecord(currentYetaiDetail.id))
    }
    else{
      navigate('/home')
    }
    
  }, []);

  let lng = '';
  let lat = '';

  return (

    <Container sx={{ padding: 0 }}>
      <Box marginTop={0}>
        <Swiper
          modules={[Navigation, Pagination, Scrollbar, A11y]}
          spaceBetween={50}
          slidesPerView={1}
          // pagination={{ clickable: true }}
          scrollbar={{ draggable: true }}
          onSwiper={(swiper) => console.log(swiper)}
          onSlideChange={() => console.log('slide change')}
        >
          {currentYetaiDetail && [storageURL + currentYetaiDetail.thumb].map((item, i) => (
            <SwiperSlide key={i}>
              <Typography
                variant={'h6'}
                align={'center'}
              >
                <img style={{ objectFit: 'cover', width: '100%', height: "250px" }} src={item}></img>
              </Typography>
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
      <Container sx={{ position: 'relative', zIndex: 9, padding: '20px', borderTopLeftRadius: '10px', borderTopRightRadius: '10px', marginTop: '-1.5rem', backgroundColor: theme.palette.primary.darkwhite }}>
        <Grid container style={{ marginTop: "10px" }} spacing={0} direction="column">
          {currentYetaiDetail && <Grid item container justifyContent="space-between" spacing={2}>
            <Grid container direction="column" item xs={8}>
              <Grid item sx={{ fontWeight: "bold", fontSize: 'large' }}>{currentYetaiDetail.name}</Grid>
              <Grid item>
                <Stack spacing={1} direction="row">
                  <Rating size="small" name="half-rating-read" defaultValue={5 * currentYetaiDetail.score / 100} precision={0.5} readOnly />
                  <Typography sx={{ fontSize: 12 }} color="text.secondary">
                    2.5
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
            <Grid item container justifyContent="space-between" spacing={0}>
              <Grid container direction="column" item xs={8}>
                {/* <Grid item>xx区xx县</Grid> */}
                <Grid item sx={{ color: "#999" }}>{currentYetaiDetail.addr}</Grid>
              </Grid>
              <Grid item container xs={4} spacing={1} alignContent='center' alignItems='center'>
                {/* <Grid item container direction="column" alignItems={"center"} xs={4} onClick={likedClick}>
                  {
                    yetaiLiked.includes(currentYetaiDetail.id) ? <FavoriteIcon color='mgreen' /> : <FavoriteBorderIcon color='mgreen' />
                  }
                  <Box style={{ fontSize: ".8rem", textAlign: 'center' }}>
                    喜欢
                  </Box>
                </Grid>
                <Grid item container direction="column" alignItems={"center"} xs={4} >
                  <img src={locate} style={{ height: "1.5rem", display: 'block' }}></img>
                  <Box onClick={daoHangHandler} style={{ fontSize: ".8rem", textAlign: 'center' }}>
                    导航
                  </Box>
                </Grid>
                <Grid onClick={phoneHandler} item container direction="column" alignItems={"center"} xs={4} >
                  <img src={phone} style={{ height: "1.4rem", marginTop: '-2px', display: 'block' }}></img>
                  <Box style={{ fontSize: ".8rem", textAlign: 'center' }}>
                    电话
                  </Box>
                </Grid> */}

              </Grid>
            </Grid>
            <Grid item container sx={{ marginTop: "15px", paddingBottom: "40px" }}>
              <Typography component="div" dangerouslySetInnerHTML={{ __html: currentYetaiDetail.desc }} />
            </Grid>
          </Grid>}
        </Grid>
      </Container >
    </Container >
  );
}